import { hasAlipayCardQuery } from '@/api/shopmember'; // 请求获取会员等级和水羊币账户信息
import { SET_MEMBER_INFO, SET_MEMBER_INFO_ALI_CARD } from '@/vuex/mutations-types';
// vipMemberGetVipMemberAndCreditInfo as fetchGetVIPMemberInfo

const state = {
  memberCardStatus: 'NONE',
  hasFreeVipCard: false,
  status: 'EXPIRE',
  typeName: 'VIP',
  memberData: {
    hasAlipayCard: 0,
  },
};

const mutations = {
  [SET_MEMBER_INFO](state, value) {
    state.memberData = value;
    const { hasFreeVipCard, status, typeName } = value;
    state.hasFreeVipCard = hasFreeVipCard;
    state.status = state;
    state.memberCardStatus = status;
    state.typeName = typeName;
  },
  [SET_MEMBER_INFO_ALI_CARD](state, value) {
    const { hasAlipayCard } = value;
    state.memberData.hasAlipayCard = hasAlipayCard;
  },
};

const actions = {
  // async getVIPMemberInfo({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     fetchGetVIPMemberInfo().then((result) => {
  //       if (result.success && result.data) {
  //         const data = result.data;
  //         commit(SET_MEMBER_INFO, data);
  //       }
  //       resolve(result);
  //     }).catch((err) => {
  //       reject(err);
  //     });
  //   });
  // },




















};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
